import React from 'react'
import FooterSidebarWrapper from './styles';
// import UserCredit from 'layout/PrivateLayout/FooterSidebar/UserCredit';
// import UserPlan from 'layout/PrivateLayout/FooterSidebar/UserPlan';
import UserSetting from 'layout/PrivateLayout/FooterSidebar/UserSetting';
// import UserSettingShort from 'layout/PrivateLayout/FooterSidebar/UserSettingShort';
import { Divider } from 'antd';

type FooterSidebarProps = {
  collapsed:boolean
}

export default function FooterSidebar({collapsed}:FooterSidebarProps) {
  return (
    <FooterSidebarWrapper>
      {/* <Space size={20} className='w-full px-4' direction='vertical'>
      {!collapsed &&<UserCredit/>}
      {!collapsed &&<UserPlan/>}
      </Space> */}
      <Divider />
      {/* {!collapsed &&<UserSetting />}
      {collapsed && <UserSettingShort/>} */}

      <UserSetting collapsed={collapsed} />
    </FooterSidebarWrapper>
  )
}
